<template>
  <div>
    <div class="sucesso" v-if="dados.type == 'SUCESSO'">
      <img :src="icons.sucesso" alt="Sucesso" width="140" />
      <span>{{ this.dados.mensagem }}</span>
    </div>
    <div class="erro" v-if="dados.type == 'ERRO'">
      <img :src="icons.error" alt="Erro" width="140" />
      <span>{{ this.dados.mensagem }}</span>
    </div>

    <div class="tela-aguarde" v-if="dados.type == 'AGUARDE'">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status"></div>
      </div>
      <span class="visually-hidden">{{ this.dados.mensagem }}</span>
    </div>
  </div>
</template>

<script>
import icons from "@/shared/components/SvgIcon.js";

export default {
  name: "Sucesso",
  props: {
    dados: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      icons,
      intervalGoto: null,
    };
  },

  watch: {
    dados: {
      deep: true,
      handler(val) {
        this.intervalGoto = setTimeout(() => {
          if (val.goto) {
            this.$router.push({ path: val.goto });
          } else {
            if (val.type !== "AGUARDE") {
              val.type = "NONE";
            }
          }
        }, 1800);
      },
    },
  },
  created() {},
  destroyed() {
    clearInterval(this.intervalGoto);
  },
};
</script>

<style scoped lang="scss">
.sucesso {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--cor-principal) !important;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.erro {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fb0c06;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.tela-aguarde {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--cor-principal);
  color: var(--cor-texto);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
span {
  padding: 5vw 10vw;
  text-transform: uppercase;
  color: #fff;
  font-size: 1.1rem;
  letter-spacing: 0.15rem;
  font-weight: bold;
  text-align: center;
}
</style>
